import styled from 'styled-components'
import { Row, theme } from '@/client/components'
const { space } = theme

export const RowBreadcrumb = styled(Row)`
  padding-top: ${space.lg};
`
